package co.uk.sacursoftware.ssinventory

import web.navigator.navigator

class JsPlatform : Platform {
    private val userAgent = navigator.userAgent
    private val browserList = listOf("Chrome", "Firefox", "Safari", "Edge")

    override val name: String = userAgent.findAnyOf(browserList, ignoreCase = true)
            ?.let { (startIndex) -> userAgent.substring(startIndex).substringBefore(" ") }
            ?: "Unknown"
    override val isMobile: Boolean = false
    override val isWeb: Boolean = true
}

actual fun getPlatform(): Platform = JsPlatform()